import { Box } from "@material-ui/core";
import { FC } from "react";
import { useGroupHeaderStyle } from "../../../../style/group-header.style";

export const CreateGroupHeader: FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;
  const headerStyle = useGroupHeaderStyle();
  return <Box className={headerStyle.createHeader}>{children}</Box>;
};
